<div class="row">
    <div class="col-md-12 col-xs-12">
        <div class="d-flex flex-column vh-100">
            <div class="flex-grow-1">
                <ag-grid-angular
                    class="ag-theme-alpine"
                    (gridReady)="gridSetting($event)"
                    [gridOptions]="gridOptions"
                    [rowData]="trucks"
                    [columnDefs]="columnDefs"
                    [pagination]= "true"
                    [paginationPageSize]="10"
                    [paginationPageSizeSelector]="[10,20,30]"
                    [enableCellTextSelection]="true"
                    >
                </ag-grid-angular>
            </div>
        </div>
        </div>
</div>
